<template>
  <div :class="`users-list is-${status === 'online' ? 'online' : 'hide'}`">
    <status-group-icon :status="getStatusClass(status)" />
    <div
      v-for="user in users"
      v-bind="getAttributes(user)"
      :key="user.id"
      :data-user-id="user.id"
      :class="getUserClasses(user)"
      @click="openChatConversation(user.id)"
    >
      <avatar
        v-if="user.status_label === 'Call' || user.status_label === 'Video Call'"
        type="coach"
        :image="user.image"
        :alt="user.name"
        :status="user.status"
        :status-class="user.css"
      />
      <avatar v-else :image="user.image" :alt="user.name" :status="user.status" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getFloatingChatRooms, isFloating, openChatRoom } from "../../../services/api/uni-chat";
import ChatContainer from "../../../features/uni-chat/ChatContainer.vue";
import Avatar from "../../../components/Avatar.vue";
import StatusGroupIcon from "../../../components/icon/StatusGroup.vue";

export default {
  name: "UsersList",
  components: {
    ChatContainer,
    Avatar,
    StatusGroupIcon
  },
  props: {
    users: {
      type: [Array, Object],
      default: []
    },
    status: {
      type: String,
      default: 'offline'
    },
    label: {
      type: String,
      default: 'Inactive'
    }
  },
  computed: {
    ...mapState("chat", ["activeConversation"])
  },
  watch: {
    status(value) {
      this.getStatusClass(value)
    }
  },
  methods: {
    ...mapMutations("chat", ["SET_CHAT_ROOMS", "SET_SHOW_CHAT_CONTAINER"]),

    shouldShowUsers(user) {
      const validStatus = ['online', 'offline', 'training', 'lunch'];
      return (validStatus.includes(user.status) ? user.status === this.status : user.status_label === this.label);
    },
    getAttributes(user) {
      const attributes = {};

      if (user.status === 'online') {
        attributes['data-toggle'] = 'tooltip';
        attributes['data-placement'] = 'left';
        attributes['data-html'] = true;
        attributes['data-original-title'] = user.name+"<br>"+user.branch.city+" | "+user.position;
      }

      return attributes;
    },
    getUserClasses(user) {
      return [
        'user-online',
        `user-online-${user.id}`,
        this.getStatusClass(this.status),
        { 'is-show': this.shouldShowUsers(user) }
      ];
    },
    getStatusClass(status) {
      const statusClasses = {
        'online': 'is-active',
        'visit': 'is-visit',
        'training': 'is-training',
        'lunch': 'is-lunch',
        'dnd': 'is-dnd',
        'call': 'is-call',
        'video-call': 'is-video-call'
      };

      return statusClasses[status] || 'is-inactive';
    },
    async openChatConversation(user_id) {
      try {
        const response = await openChatRoom(user_id);
        const roomId = response?.data?.room_id;

        if (roomId !== this.activeConversation) {
          const rooms = await getFloatingChatRooms('1');

          this.SET_SHOW_CHAT_CONTAINER(true);
          this.SET_CHAT_ROOMS(rooms.data);
        } else {
          isFloating({ room_id: this.activeConversation, is_floating: false });
        }
      } catch (error) {
        console.error('Error opening chat conversation:', error);
      }
    }
  }
}
</script>